Namespace 'CustomerVisualMode.Filters.Unapplied'

class CustomerVisualMode.Filters.Unapplied.UnappliedDateFilterTypeSelectorRangeView extends Backbone.View
  template: JST['backbone/templates/common/dashboard/filters/unapplied/unapplied_date_filter_type_selector_range']
  className: 'date-range-selectors'

  events:
    'change #until-now': '_onUntilNow'

  initialize: ({range, type}) ->
    @range = range
    @type = type
    @dateLowerBound = @_computeDateLowerBound()

  render: ->
    @$el.empty().append @template()
    @_initializeStartDatetimePicker(@range.start_time)
    @_initializeEndDatetimePicker(@range.end_time)
    @checkUntilNow(@_isUntilNowRange())
    @

  selectedRange: ->
    start_time: @rangeStartTimeView.getDatetime()
    end_time: @_endTime()

  rangeType: ->
    @type

  _isUntilNowRange: ->
    @type == CustomerVisualMode.Filters.DateFilter.TYPES.DATE_RANGE_UNTIL_NOW

  _isDateRange: ->
    @type == CustomerVisualMode.Filters.DateFilter.TYPES.DATE_RANGE

  _endTime: ->
    @rangeEndTimeView.getDatetime() if @_isDateRange()

  togglePickers: (display) ->
    @_toggleStartTimeView(not display)
    @_toggleEndTimeView(not display)
    @_untilNowCheckbox().prop('disabled', not display)
    @$el.find('.until-now-label').toggleClass('disabled', not display)

  _checkInvalidRange: (range) ->
    isStartRange = range == @rangeStartTimeView
    startDatetime = @rangeStartTimeView.getDatetime()
    endDatetime = @rangeEndTimeView.getDatetime()
    if startDatetime > endDatetime
      if isStartRange
        @_initializeEndDatetimePicker(startDatetime)
      else
        @_initializeStartDatetimePicker(endDatetime)

  _initializeStartDatetimePicker: (start_time) ->
    @rangeStartTimeView?.remove()
    options = {defaultDate: start_time, required: true}
    options.startDate = @dateLowerBound if @dateLowerBound
    @rangeStartTimeView = new Common.DatetimeView(options)
    @$('.datetime-picker-start-time').empty().append @rangeStartTimeView.render().el
    @listenTo(@rangeStartTimeView, 'change', => @_checkInvalidRange(@rangeStartTimeView))

  _initializeEndDatetimePicker: (end_time) ->
    @rangeEndTimeView?.remove()
    options = {defaultDate: end_time, required: true}
    options.startDate = @dateLowerBound if @dateLowerBound
    @rangeEndTimeView = new Common.DatetimeView(options)
    @$('.datetime-picker-end-time').empty().append @rangeEndTimeView.render().el
    @listenTo(@rangeEndTimeView, 'change', => @_checkInvalidRange(@rangeEndTimeView))

  # Existing filters whose stored range predates the 3-year window keep it:
  # the lower-bound restriction is skipped so old dates render and stay valid.
  _computeDateLowerBound: ->
    threeYearsAgo = new Date()
    threeYearsAgo.setFullYear(threeYearsAgo.getFullYear() - 3)
    for time in [@range.start_time, @range.end_time]
      return null if time and new Date(time) < threeYearsAgo
    threeYearsAgo

  _onUntilNow: (event) ->
    checked = event.target.checked
    @_setType(checked)
    @_toggleEndTimeView(checked)

  checkUntilNow: (checked) ->
    @_untilNowCheckbox().prop('checked', checked)
    @_setType(checked)
    @_toggleEndTimeView(checked)

  _setType: (checked) ->
    if checked
      @type = CustomerVisualMode.Filters.DateFilter.TYPES.DATE_RANGE_UNTIL_NOW
    else
      @type = CustomerVisualMode.Filters.DateFilter.TYPES.DATE_RANGE

  _untilNowCheckbox: ->
    @$el.find('#until-now')

  _toggleEndTimeView: (disable) ->
    if (disable)
      @rangeEndTimeView.disable(false)
    else
      @rangeEndTimeView.enable() unless @_isUntilNowRange()
    @_toggleDateRangeLabel('.date-range-end-time', disable || @_isUntilNowRange())

  _toggleStartTimeView: (disable) ->
    if (disable)
      @rangeStartTimeView.disable(false)
    else
      @rangeStartTimeView.enable()
    @_toggleDateRangeLabel('.date-range-start-time', disable)

  _toggleDateRangeLabel: (rangeSelector, disable) ->
    @$el.find("#{rangeSelector} .title").toggleClass('disabled', disable)
